import { axiosInstance } from '@/providers/axiosInstance';

interface AdminConfig {
  langSmithOrgId: string | undefined;
  langSmithProjectId: string | undefined;
}

let cachedConfig: AdminConfig | null = null;

export async function fetchAdminConfig(): Promise<AdminConfig> {
  if (cachedConfig) return cachedConfig;
  const response = await axiosInstance.get<AdminConfig>('/api/admin/config');
  cachedConfig = response.data;
  return cachedConfig;
}

export function buildLangSmithUrl(
  workflowRunId: string,
  config: AdminConfig | null
): string | null {
  if (config?.langSmithOrgId && config?.langSmithProjectId) {
    return `https://smith.langchain.com/o/${config.langSmithOrgId}/projects/p/${config.langSmithProjectId}?peek=${workflowRunId}&peeked_trace=${workflowRunId}`;
  }
  return null;
}
